import { Route } from "react-router-dom";
import { APP_URLS } from "../../../utils/constant";
import VehicleTrimScreen from "../../../container/Vehicles/VehicleTrimScreen";
import CreateVehicleTrim from "../../../container/Vehicles/VehicleTrimScreen/CreateVehicleTrim";


const VehicleTrimRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.VEHICLE_TRIM.HOME}
          element={<VehicleTrimScreen screenPermissions={access} />}
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.VEHICLE_TRIM.CREATE}
          element={<CreateVehicleTrim />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.VEHICLE_TRIM.EDIT}
          element={<CreateVehicleTrim isEdit={true} />}
        />
      )}
    </>
  );
};

export default VehicleTrimRoutes;
